import hassleFreeSCurve from "static/images/landing-page/hassle-free-s-curve.svg";
import portfolioReportingLogo from "static/images/landing-page/portfolioReportingLogo.svg";
import flexibleScaleLogo from "static/images/landing-page/flexibleScaleLogo.svg";
import LandingPageHeading from "./LandingPageHeading";

export default function TimePhasingFeatures() {
  const Feature = ({
    textLeft,
    text,
    heading,
    image,
  }: {
    textLeft: boolean;
    heading: string;
    text: string;
    image: { src: string; altText: string };
  }) => {
    return (
      <div className="flex flex-col lg:flex-row items-center gap-y-16">
        <div
          className={`flex ${
            textLeft ? "order-1" : "order-1 lg:order-2"
          } w-full lg:w-1/2 justify-center items-center`}
        >
          <div className="max-w-415px">
            <LandingPageHeading text={heading} classNames="mb-4" />
            <div className="font-medium leading-7">{text}</div>
          </div>
        </div>
        <div
          className={`flex ${
            textLeft ? "order-2" : "order-2 lg:order-1"
          } w-full lg:w-1/2  justify-center items-center`}
        >
          <img src={image.src} alt={image.altText} />
        </div>
      </div>
    );
  };

  return (
    <div className="space-y-10 lg:space-y-33">
      <Feature
        textLeft={true}
        heading="Hassle-free S-curve generation"
        text="Our time-phasing API is fast, rendering new S-curves at the touch of a button. Edits to source data are reflected immediately, enabling your project managers to plan and model without delay."
        image={{
          src: hassleFreeSCurve,
          altText: "S-curve generation from time-phasing API",
        }}
      />

      <Feature
        textLeft={false}
        heading="Portfolio reporting"
        text="Consolidate multiple projects into one S-curve using our project schedule phasing service, even if you are using multiple planning tools."
        image={{
          src: portfolioReportingLogo,
          altText: "Portfolio reporting with time-phased data",
        }}
      />

      <Feature
        textLeft={true}
        heading="Flexible at any scale"
        text="Our high-performance time-phasing algorithms are suitable for large- and small-scale use. Project schedule phasing is a complex task whether your activity list counts below 100 or exceeds 10s of thousands with multiple calendars and profiles."
        image={{
          src: flexibleScaleLogo,
          altText: "Flexible time-phasing API at scale",
        }}
      />
    </div>
  );
}
